/* eslint-disable @typescript-eslint/no-unused-vars */
import storeInfo from '../store'
import { PromoCodeType } from './types'

export const getPromoCodes = () => (): PromoCodeType[] => {
  const { promoCodes } = storeInfo.store.getState()
  return promoCodes ? promoCodes : []
}